// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"MarcaUnidadTable_spinnerContainer__tVcEr","botonAdd":"MarcaUnidadTable_botonAdd__3p4-R"};